<script lang="ts">
  import type { Snippet } from 'svelte';

  interface TabItem {
    title: string;
    active: boolean;
    href: string;
  }

  interface Props {
    children: Snippet;
    tabs: TabItem[];
    overflowScroll?: boolean;
  }

  let { children, tabs, overflowScroll = false }: Props = $props();
</script>

<ul class="nav nav-tabs justify-content-center">
  {#each tabs.map((t, i) => ({ t, i })) as tab (tab.i)}
    <li class="nav-item">
      <a
        class="nav-link"
        class:active={tab.t.active}
        aria-current={tab.t.active ? 'page' : undefined}
        href={tab.t.href}
      >
        {tab.t.title}
      </a>
    </li>
  {/each}
</ul>
<div class="card">
  <div class="card-body">
    {@render children?.()}
  </div>
</div>

<style>
  .nav {
    position: relative;
    z-index: 1;
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .card {
    margin-top: -1px;
    --bs-card-border-color: var(--bs-border-color);
  }
</style>
